import React from 'react';
import type { ConnectedSourceId } from '../types';
import { PerformanceLoader } from './PerformanceLoader';
import { DrillToolbar } from './shared/DrillToolbar';
import { DrillMetricTabs, type DrillTabDef } from './shared/DrillMetricTabs';

export function DrillLoadingOverlay({
  onClose,
  belowTopbar = false,
  periodLabel,
  activeMetric,
  reviewsAvailable,
  connected,
  onSwitchMetric,
  'data-ftue': dataFtue,
}: {
  onClose: () => void;
  belowTopbar?: boolean;
  periodLabel?: string;
  activeMetric?: string;
  reviewsAvailable?: boolean;
  connected?: ConnectedSourceId[];
  onSwitchMetric?: (tab: DrillTabDef) => void;
  'data-ftue'?: string;
}) {
  return (
    <div
      className={`drill drill-loading${belowTopbar ? ' drill-below-topbar' : ''}`}
      data-ftue={dataFtue}
    >
      <DrillToolbar onClose={onClose} periodLabel={periodLabel}>
        {activeMetric && onSwitchMetric ? (
          <DrillMetricTabs
            active={activeMetric}
            reviewsAvailable={reviewsAvailable}
            connected={connected}
            onSelect={onSwitchMetric}
          />
        ) : null}
      </DrillToolbar>
      <div className="drill-body drill-loading-body">
        <PerformanceLoader />
      </div>
    </div>
  );
}
